<template>
  <div class="mb-4">
    <label :for="setting.name">
      {{ setting.label }}
    </label>

    <SettingsMessage v-if="setting.message" :message="setting.message" />

    <Input
      v-if="!setting.multiline"
      :name="setting.name"
      type="text"
      class="input"
      :value="setting.textValue"
      :maxlength="setting.maxLength"
      :disabled="saving"
      :loading="saving"
      @blur="onInputUpdate($event.target.value)"
    />

    <RichInput
      v-if="setting.multiline"
      :value="setting.textValue"
      :disabled="saving"
      :loading="saving"
      :maxlength="setting.maxLength"
      :multi-line="setting.multiline"
      @blur="onInputUpdate"
    />
  </div>
</template>

<script>
import clone from "just-clone";
import RichInput from "@/components/UI/RichInput";
import Input from "@/components/UI/Input";
import SettingsMessage from "./SettingsMessage";

// saving: {
export default {
  name: "TextSetting",
  components: { Input, RichInput, SettingsMessage },
  props: {
    saving: {
      default: false,
      type: Boolean,
    },
    setting: {
      type: Object,
      required: true,
      id: {
        required: true,
        type: String,
      },
      name: {
        required: true,
        type: String,
      },
      label: {
        required: true,
        type: String,
      },
      maxLength: Number,
      multiline: Boolean,
      textValue: String,
    },
  },
  methods: {
    displayInvalidAlert(value) {
      const text = `Please shorten your text. Input can't be longer than ${this.setting.maxLength} characters.`;

      this.$modal.show("dialog", {
        title: "Ot oh 😮",
        text,
        buttons: [
          {
            title: "Close",
          },
        ],
      });
    },
    isValid(count) {
      return count <= this.setting.maxLength;
    },
    onInputUpdate(value, count) {
      // Check for a count parameter if not use the length value of the input
      // This is so we don't include html characters in the validation check...
      const characterCount = count || (value?.length ?? 0);

      if (this.isValid(characterCount)) {
        const setting = clone(this.setting);
        setting.textValue = value;
        this.$emit("setting-updated", setting, value);
      } else {
        // Let the user know their input was invalid...
        this.displayInvalidAlert();
      }
    },
  },
};
</script>

<style scoped>
.input[disabled] {
  opacity: 0.7;
}
</style>
